<div class="wizard-step-content">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="mb-1">
        <i class="fa fa-address-book text-primary me-2"></i>
        {{ 'eventWizard.contacts.title' | translate }}
      </h3>
      <p class="text-muted mb-0">{{ 'eventWizard.contacts.subtitle' | translate }}</p>
    </div>
    <app-button
      [variant]="'primary'"
      [label]="'eventWizard.contacts.addContact' | translate"
      [iconClass]="'fa fa-plus'"
      [disabled]="!event"
      (clicked)="openAddContactModal()"
    />
  </div>

  @if (!event) {
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ 'eventWizard.contacts.completeBasicFirst' | translate }}
    </div>
  } @else if (contacts.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-address-book fs-3x text-muted mb-4 d-block opacity-50"></i>
      <h5 class="text-muted mb-2">{{ 'eventWizard.contacts.noContactsYet' | translate }}</h5>
      <p class="text-muted mb-4">{{ 'eventWizard.contacts.contactsOptional' | translate }}</p>
    </div>
  } @else {
    <div class="row g-4">
      @for (contact of contacts; track contact.contact_id) {
        <div class="col-md-6 col-lg-4">
          <div class="card h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-50px me-3">
                    <span class="symbol-label bg-light-primary">
                      <i class="fa fa-user text-primary fs-4"></i>
                    </span>
                  </div>
                  <div>
                    <h5 class="mb-0">{{ contact.first_name }} {{ contact.last_name }}</h5>
                    @if (contact.role?.role_name) {
                      <span class="badge badge-light-primary">{{ contact.role?.role_name }}</span>
                    }
                  </div>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-icon btn-light"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" (click)="openEditContactModal(contact)">
                        <i class="fa fa-edit me-2"></i>{{ 'common.edit' | translate }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteContact(contact)">
                        <i class="fa fa-trash me-2"></i>{{ 'common.delete' | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              @if (contact.email) {
                <div class="d-flex align-items-center mb-2">
                  <i class="fa fa-envelope text-muted me-2"></i>
                  <span class="text-muted">{{ contact.email }}</span>
                </div>
              }
              @if (contact.phone) {
                <div class="d-flex align-items-center">
                  <i class="fa fa-phone text-muted me-2"></i>
                  <span class="text-muted">{{ contact.phone }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <div class="alert alert-light-info border border-info border-dashed mt-4">
      <div class="d-flex align-items-center">
        <i class="fa fa-info-circle text-info fs-2 me-3"></i>
        <div>
          <strong>{{ 'eventWizard.contacts.contactsAdded' | translate:{ count: contacts.length } }}</strong>
          <div class="text-muted">{{ 'eventWizard.contacts.continueOrAddMore' | translate }}</div>
        </div>
      </div>
    </div>
  }
</div>
